export function paramsFromQuery(mainParams, queryParams, status){
  console.log(queryParams,"queryparams")
  let bs = queryParams.bs
  let sortKey = queryParams.sortKey;
  let sortDir = queryParams.sortDir;
  let page = queryParams.pageNo
  if(status){
    mainParams['status_id'] = status
    // mainParams['as'] = true
  }
  if(queryParams.is_advanced_search) {
    mainParams["is_advanced_search"] = "true";
  }
  if(bs){
    // mainParams['as'] = true
    mainParams['bs'] = bs;
  }
  if(sortKey){
    mainParams['key'] = decodeSortKey(sortKey)
    mainParams['sort'] = sortDir || 'asc'
  }
  if(page){
    mainParams['page'] = page
  }
}
export function prepareLeadSearchParams(advSParams, status_id){
  let toSend = {}
    toSend['name'] = advSParams.name
    toSend['phone'] = advSParams.phone
    toSend['email'] = advSParams.email
    toSend['budget_from']= advSParams.budget_from
    toSend['budget_upto']= advSParams.budget_upto
    toSend['city_id']= advSParams.city_id
    toSend['status_id']= status_id
    toSend['is_advanced_search'] = true
  return toSend;
}

export function updateLeadParams(leadParams){
  let toSend = {}
    toSend['name'] = leadParams.name
    toSend['status_id'] = leadParams.status_id
    if (leadParams.dead_reason) {
      toSend['dead_reason'] = leadParams.dead_reason
    }
    toSend['city_id']= leadParams.city_id
    toSend['budget']= leadParams.budget
    toSend['users_comments']= leadParams.users_comments
  return toSend;
}